import { useAtom } from 'jotai';
import { useCallback, useMemo } from 'react';
import { activateSubscriptionModalAtom } from './atoms';

export function useActivateSubscriptionModalV2() {
  const [activateSubscriptionModal, setActivateSubscriptionModal] = useAtom(
    activateSubscriptionModalAtom
  );

  const handleOpen = useCallback(
    (subscriptionId: number) => {
      setActivateSubscriptionModal({
        subscriptionId
      });
    },
    [setActivateSubscriptionModal]
  );

  const handleClose = useCallback(() => {
    setActivateSubscriptionModal({
      subscriptionId: undefined
    });
  }, [setActivateSubscriptionModal]);

  return useMemo(
    () => ({
      subscriptionId: activateSubscriptionModal.subscriptionId,
      isOpen: activateSubscriptionModal.subscriptionId !== undefined,
      handleOpen,
      handleClose
    }),
    [activateSubscriptionModal.subscriptionId, handleClose, handleOpen]
  );
}
